import { addAsync as _addAsync, deleteAllAsync as _deleteAllAsync } from "../../api";

const BASE_URL = "/coc/requests";

export async function addAsync(requestId, payload) {
    return _addAsync({ url: `${BASE_URL}/${requestId}/evidences/${payload.cocRequestEvidencesId}/docs`, data: payload });
}

export async function deleteAsync(requestId, evidenceId, docId) {
    return _deleteAllAsync({ url: `${BASE_URL}/${requestId}/evidences/${evidenceId}/docs`, data: { ids: [docId] } });
}
